import { helper } from '@ember/component/helper';

export default helper(function getStudentSection([
  sectionMap,
  studentId,
  templateSectionId,
]) {
  if (!sectionMap || !studentId || !templateSectionId) {
    return null;
  }
  let studentSections = sectionMap[studentId];
  if (!studentSections) {
    return null;
  }
  return studentSections[templateSectionId] || null;
});
